__turbopack_context__.v({
  "buttonGroup": "buttonGroup-module-scss-module__0o5RpW__buttonGroup",
});
